class PredictiveSearch extends SearchForm {
  constructor() {
    super();

    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
    this.initChips();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

   

  toggleDefaultState(showDefault) {
    const defaultBlock = this.querySelector('.predictive-search__default');
    const resultsBlock = this.querySelector('[data-predictive-search]');
    const mainResultsBlock = this.querySelector('.predictive-search ');


    if (showDefault) {
      defaultBlock?.classList.remove('hidden');
      resultsBlock?.classList.add('hidden');
      mainResultsBlock?.classList.remove('hidden')
      

      defaultBlock?.setAttribute('aria-hidden', 'false');
      resultsBlock?.setAttribute('aria-hidden', 'true');
    } else {
      defaultBlock?.classList.add('hidden');
      resultsBlock?.classList.remove('hidden');

      defaultBlock?.setAttribute('aria-hidden', 'true');
      resultsBlock?.setAttribute('aria-hidden', 'false');
    }
  }

   

  onChange() {
    super.onChange();

    const newSearchTerm = this.getQuery();

    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    if (!newSearchTerm.length) {
      this.toggleDefaultState(true);
      this.open();
    } else {
      this.toggleDefaultState(false); 
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) return;

    this.getSearchResults(this.searchTerm);
  }

   

  onFocus() {
    const currentSearchTerm = this.getQuery();

    this.open();

    if (!currentSearchTerm.length) {
      this.toggleDefaultState(true);
      return;
    }

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.toggleDefaultState(false);
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

   

  onKeyup(event) {
    const query = this.getQuery();

    if (!query.length) {
      this.toggleDefaultState(true);
      this.open();
    }

    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

   

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
      event.preventDefault();
    }
  }

  onFormReset(event) {
    super.onFormReset(event);

    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

   

  updateSearchForTerm(previousTerm, newTerm) {
    const el = this.querySelector('[data-predictive-search-search-for-text]');
    const currentText = el?.innerText;

    if (!currentText) return;

    if (currentText.match(new RegExp(previousTerm, 'g'))?.length > 1) return;

    el.innerText = currentText.replace(previousTerm, newTerm);
  }

   

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();

    this.setLiveRegionLoadingState();

    // Abort previous request
    this.abortController.abort();
    this.abortController = new AbortController();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((res) => {
        if (!res.ok) {
          this.close();
          throw new Error(res.status);
        }
        return res.text();
      })
      .then((text) => {
        const html = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        this.allPredictiveSearchInstances.forEach((instance) => {
          instance.cachedResults[queryKey] = html;
        });

        this.renderSearchResults(html);
      })
      .catch((err) => {
        if (err?.code === 20) return;
        this.close();
        throw err;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    this.setAttribute('results', true);
    this.setLiveRegionResults();

    
    this.toggleDefaultState(false);

    this.open();

    this.initChips();
  }

   

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(text) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = text;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(
      this.querySelector('[data-predictive-search-live-region-count-value]').textContent
    );
  }

   

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selected = this.querySelector('[aria-selected="true"]');

    const items = Array.from(
      this.querySelectorAll('li, button.predictive-search__item')
    ).filter((el) => el.offsetParent !== null);

    let index = items.indexOf(selected);

    if (moveUp) {
      index = index <= 0 ? items.length - 1 : index - 1;
    } else {
      index = index === items.length - 1 ? 0 : index + 1;
    }

    if (selected) selected.setAttribute('aria-selected', false);

    const active = items[index];
    active.setAttribute('aria-selected', true);
    this.input.setAttribute('aria-activedescendant', active.id);
  }

  selectOption() {
    const selected = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (selected) selected.click();
  }

  

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight -
      document.querySelector('.section-header')?.getBoundingClientRect().bottom;

    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;

    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;

    if (!this.getQuery().length) {
      this.toggleDefaultState(true);
    }
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
    this.toggleDefaultState(true);
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);

    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }

  

  initChips() {
    this.querySelectorAll('.chip').forEach((chip) => {
      if (chip.dataset.bound) return;

      chip.dataset.bound = 'true';

      chip.addEventListener('click', () => {
        this.input.value = chip.dataset.query;
        this.input.dispatchEvent(new Event('input'));
        this.input.focus();
      });
    });
  }
}

customElements.define('predictive-search', PredictiveSearch);